import { transparentize } from 'polished'
import { isOnServer } from '@shared/constants/util'
import { Z_INDEX_MODAL } from '@/features/shared/constants/global'

export const setupReactModal = () => {
  if (isOnServer()) return

  const rootElement = document.getElementById('__next')
  // this moves the aria-hidden="true" from the body to the div#root
  // by doing so, screenreaders will be able to access the modal content but not the main document content
  if (rootElement) {
    import('react-modal').then(({ default: ReactModal }) => {
      ReactModal.setAppElement(rootElement)

      ReactModal.defaultStyles = {
        overlay: {
          display: 'flex',
          alignItems: 'center',
          backgroundColor: transparentize(0.5, 'black'),
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: Z_INDEX_MODAL,
        },
      }
    })
  }
}
